<template>
    <v-card tile class="notification" :class="{seen: seen, new: !seen, 'cursor-pointer': !!to}" v-ripple="ripple" :to="to" @click="clicked">
        <div class="d-flex">

            <div class="icon-wrapper me-4">
                <div class="icon grey lighten-4">
                    <v-icon :color="color + ' darken-1'" size="26">{{icon.icon}}</v-icon>
                </div>
                <span class="time small-text" :class="{'grey--text': seen, 'font-weight-bold primary--text': !seen}">
                    <!-- <v-icon v-show="!seen" size="8" class="primary--text">mdi-circle</v-icon> -->
                    <!-- {{seen ? time : ''}} -->
                </span>
            </div>
            <div class="flex-grow-1 notification-details overflow-hidden">
                <v-card-title class="title pa-0" :class="{'rtl-dir justify-end text-left': detectDir(title) === 'rtl', [titleColor]: true}">{{title}}</v-card-title>
                <v-card-subtitle class="ma-0 pa-0" :class="{'primary--text': !seen, 'rtl-dir justify-end text-left': detectDir(content) === 'rtl',}" ><div v-html="urlify(escapeHtmlText(content))" class="content"></div></v-card-subtitle>
            </div>

        </div>
    </v-card>
</template>
<script>

import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';


export default {
    props: ['notification'],
    data(){
        return {
            time: '',
        }
    },
    computed: {
        type(){
            return this.notification.data.type;
        },
        title(){
            return this.notification.data.title;
        },
        content(){
            return this.notification.data.content;
        },
        icon(){
            let icon = 'mdi-bell-outline';
            const type = this.type;
            if (type === 'ticket_reply'){
                icon = 'mdi-help';
            }else if (type === 'admin_message'){
                icon = 'mdi-email';
            }else if (type === 'course_enrolled'){
                icon = 'mdi-check';
            }else if (type === 'enrollment_action_needed'){
                icon = 'mdi-square-edit-outline';
            }else if (type === 'recharge_completed'){
                icon = 'mdi-wallet';
            }else if (type === 'class_rescheduled' || type === 'class_rescheduled_rejected'){
                icon = 'mdi-clock-edit-outline';
            }
            return {icon};
        },
        color(){
            // return color depanding on notif type
            const type = this.type;
            if (type === 'ticket_reply'){
                return 'indigo';
            }
            if (type === 'admin_message'){
                return 'green';
            }
            if (type === 'course_enrolled'){
                return 'blue-grey';
            }
            if (type === 'course_finished' || type === 'finish_enrollment_request'){
                return 'error';
            }
            if (type === 'enrollment_action_needed'){
                return 'error';
            }
            if (type === 'recharge_completed'){
                return 'green';
            }
            if (type === 'class_canceled' || type === 'class_rescheduled_rejected'){
                return 'error';
            }
            if (type === 'class_rescheduled'){
                return 'indigo';
            }
            return 'primary';
        },
        titleColor(){
            if (!this.seen){
                return `text--${this.color} text--darken-1`;
            }
            return 'text--lighten-2 black--text';
        },
        ripple(){
            return this.to ? {class: 'grey--text'} : false;
        },
        to(){
            if (this.notification.data.course_class_id || this.type === 'teacher_enrollment_approved'){
                return {name: 'calendar'};
            }
            if (this.notification.data.course_id){
                return {name: 'course', params: {id: this.notification.data.course_id}}
            }
            if (this.notification.data.program_id){
                return {name: 'program', params: {id: this.notification.data.program_id}}
            }
            if (this.notification.data.to){
                return this.notification.data.to; 
            }
            return null; 
        },
        seen(){
            return !!this.notification.read;
        }
    },
    methods: {

        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
        clicked(){
            if (this.to){
                this.$emit('navigated', true);
            }
        },
        openLink(){
            let id = this.owned ? this.msg.receiver.id : this.msg.sender.id;
            this.$router.push({name: 'profile', params: {id}})
        },

        timeFormat() {
            const self = this;
            let time = this.notification.created_at;

            if (time == 'now') {
                return "just now";
            }
            
            // Split timestamp into [ Y, M, D, h, m, s ]

            var t = time.split(/[- :]/); // splitting timestamp into array t[], so t[0] is the year .. etc

            // Apply each element to the Date function
            var d = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5])); // t[1]-1  -> months starts from 0

            d.setTime(d.getTime());

            var ms = new Date() - d;

            var since = self.timeSince(ms);
            self.time = since;

            // this is to update time every 20s
            this.intervalid1 = setInterval(function () {
                var ms = new Date() - d;

                var since = self.timeSince(ms);
                self.time = since;


            }, 20000);
        },
        timeSince (date) {

            var seconds = Math.floor(date / 1000);

            var interval = Math.floor(seconds / 31536000);

            if (interval >= 1) {
                if (interval == 1) {
                    return "1 year";
                } else {
                    return interval + " years";
                }
            }


            interval = Math.floor(seconds / 2592000);
            if (interval >= 1) {
                if (interval == 1) {
                    return "1 month";
                } else {
                    return interval + " months";
                }
            }


            interval = Math.floor(seconds / 86400);
            if (interval >= 1) {
                if (interval == 1) {
                    return "1 day";
                } else {
                    return interval + " days";
                }
            }


            interval = Math.floor(seconds / 3600);
            if (interval >= 1) {
                if (interval == 1) {
                    return "1 hour";
                } else {
                    return interval + " hours";
                }

                /*  else if (interval == 2) {
                    return "2 hours";
                } else if (interval <= 10) {
                    return "" + interval + " hours";
                } */
            }


            interval = Math.floor(seconds / 60);
            if (interval >= 1) {
                if (interval == 1) {
                    return "1 minute";
                } else {
                    return interval + " minutes";
                }

            }

            return "just now";

        },

        detectDir(text){
            const rtlChar = /[\u0590-\u083F]|[\u08A0-\u08FF]|[\uFB1D-\uFDFF]|[\uFE70-\uFEFF]/mg;
            if (text){
                if (rtlChar.test(text.charAt(0))){
                    // is rtl 
                    return 'rtl';
                }else{
                    return 'ltr';
                }
            }
            return 'ltr';
        },
    },
    mounted(){
        this.timeFormat();
    }
    
}
</script>
<style lang="scss" scoped>
    .notification{
        box-shadow: none!important;
        border-bottom: 1px solid #eee;
        padding: 1rem;
        user-select: none;
        &.cursor-pointer{
            &, .title, .content{
                cursor: pointer;
            }
        }
        &.seen{
            opacity: 0.9;
            // filter: grayscale(0.3);
        }
        &.new{
            opacity: 1;
            .content{
                color: #343434!important;
                font-size: 13.5px;
                font-weight: 500;
            }
        }
        .title{
            font-size: 1rem!important;
            line-height: 1.4rem;
            word-break: normal;
            font-weight: 500;
            margin-bottom: 0.2rem!important;
            cursor: default;
        }
        .content{
            font-size: 13px!important;
            cursor: default;
            user-select: none;
            line-height: 1.4;
        }
        .icon-wrapper{
            display: flex;
            align-items: center;
            flex-direction: column;
            .time{
                //margin-top: 12px;
                line-height: 20px;
            }
            .icon{
                width: 58px;
                height: 58px;
                border-radius: 10px;
                overflow: hidden;
                border: 1px solid;
                display: flex;
                justify-content: center;
                align-items: center;

            }
        }
    }
</style>